import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.push.js";
import indexMixin from "../mixins/index";
export default {
  name: "res-select",
  mixins: [indexMixin],

  data() {
    return {
      dataModel: this.value,
      isGroup: false // labelKey 也对分组情况下的分组label起作用

    };
  },

  props: {
    valueKey: {
      type: String,
      default: "value"
    },
    labelKey: {
      type: String,
      default: "label"
    },
    optionsKey: {
      type: String,
      default: "options"
    },
    options: {
      type: Array,
      default: () => []
    },
    slots: {
      type: Object,
      default: () => {}
    },
    multiple: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Array, String, Number]
    }
  },
  watch: {
    dataModel(val) {
      this.$emit("input", val);
    },

    value(val) {
      this.dataModel = val;
    },

    options: {
      handler(val) {
        // 根据数据判断是否分组
        this.isGroup = false;

        if (val.length) {
          val.some(element => {
            if (element[this.optionsKey] instanceof Array) {
              this.isGroup = true;
              return true;
            }
          });
        }
      },

      immediate: true
    }
  },
  computed: {
    valueToLabel() {
      let allOptions = this.options;

      if (this.isGroup) {
        // 分组
        allOptions = this.options.reduce((pre, next) => {
          return [...pre, ...next[this.optionsKey]];
        }, []);
      }

      if (this.multiple) {
        // 多选
        let label = [];
        let values = this.dataModel ? this.dataModel : [];
        allOptions.forEach(item => {
          if (this.dataModel.indexOf(item[this.valueKey]) !== -1) {
            label.push(item[this.labelKey]);
          }
        });
        label = label.join("、"); // 没有label默认取value值

        return label || values.join("、") || "无数据";
      } else {
        // 单选
        let label = "";
        allOptions.some(item => {
          if (item[this.valueKey] === this.dataModel) {
            label = item[this.labelKey];
            return true;
          }
        }); // 没有label默认取value值

        return label || this.dataModel;
      }
    }

  }
};